<template>
    <div >
      <BaseModal
        v-if="visible && labelSettings.length != 1"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :TitleWindow="$t('Patient.PatientLabels')"
        :width="'30%'"
        :height="'auto'"
        :UseScrollable="false"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.TitleOK'), variant: 'primary', action: onClickShowReport },
        ]"
        @Close="close"
        >
        <b-row>
          <b-col lg="9" md="9" sm="9">
            <MdSelect
            v-bind:Label="$t('Patient.LabelType')"
            v-bind:Options="labelSettings"
            v-bind:ModelArray="labelSettingsModel"
            v-bind:FieldDescription="'templateCode'"
            v-bind:FieldCode="'templateCode'"
            v-bind:AllowEmpty="false"
            :Input="changeLabelSettings"
            v-bind:isRequired="true"
            v-bind:isValid="isLabelTypeValid"/>
          </b-col>
        </b-row>
      </BaseModal>

      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('Patient.PatientLabels')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="PatientLabels"
          :ReportName="'LabelsReport'"
          :ReportTitle="$t('Patient.PatientLabels')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import LetterTemplatesService from '@/services/lettertemplates.service'

    export default Vue.extend({
        name: "PatientLabelsRep",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          patientCode: String,
          closeWindow: Function,
          visible: {
            type: Boolean,
            default: false
          },
        },
        data() {
            return {
              isReportVisible: false,
              modalId: 'Admissions',
              emitCloseEvent: false,
              reportParams: [],
              labelSettings: [],
              labelSettingsModel: null,
              isLabelTypeValid: true
            }
        },
        watch: {
          visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
          },
        },
        methods: {

            changeLabelSettings(item) {
                this.labelSettingsModel = item;
                this.isLabelTypeValid = item ? true : false
            },

            selectFirstItem() {
                this.labelSettingsModel = this.labelSettings.length > 0 ? this.labelSettings[0] : null
            },

            async getLabelSettings(){
              await LetterTemplatesService.getLabelSettings()
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0) {
                  this.labelSettings = response.data;
                }
              })
              .catch(error => {
                if (!error.response) {
                    // network error
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                } else {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });
            },

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
              this.close()
            },

            close() {
              this.emitEventCancel();
            },

            validateLabelType() {
                this.isLabelTypeValid = this.labelSettingsModel ? true : false
                return this.labelSettingsModel ? true : false
            },

            initializePdfParameters() {
              this.reportParams = []
              this.reportParams.push({ paramName: 'codeList', paramValue: this.patientCode})
              this.reportParams.push({ paramName: 'code', paramValue: this.labelSettingsModel.templateCode})
            },

            onClickShowReport(event) {
              // Prevenir el cierre del modal
              if (event && event.preventDefault) {
                event.preventDefault();
              }

              if (this.validateLabelType()) {
                this.initializePdfParameters();
                this.isReportVisible = true
                this.$refs.PatientLabels.buildDocument(this.reportParams)
              }
            },

            onHidden() {
              if (this.emitCloseEvent) {
                this.$emit('close');
                this.emitCloseEvent= false;
              }
            },

            emitEventCancel() {
              this.emitCloseEvent= false;
              this.$emit('close');
            },
        },

        async mounted () {
            await this.getLabelSettings()
            this.selectFirstItem()
            if (this.labelSettings.length == 1)
                this.onClickShowReport()
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {
      height: 94% !important;
  }
</style>
